import { useEffect } from "react";
import { useState } from "react";
import ApiService from "../../Core/Service/ApiService";
import CategoryTree from "./CategoryTree";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import './style.scss';
import CategoryEdit from "./CategoryEdit";
import { toast } from "react-toastify";
import { useContext } from "react";
import CmsContext from "../../Context/CmsContext";

const CategoryList = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState();
    const cmsContext = useContext(CmsContext);
    const [initializingSequence, setInitializeSequence] = useState(false);

    useEffect(() => {
        cmsContext.setBreadcrumb([
            { title: cmsContext.currMainMenu?.label ?? ''},
            { title: cmsContext.currSubMenu?.label ?? ''},
        ])
    }, [])

    useEffect(() => {
        setLoading(true);

        ApiService.get('/categories/all').then(response => {
            setCategories(response.data.categories?.map(cat => ({
                ...cat,
                branches: cat.branches?.split(','),
                logo_web: cat.logo_web ? JSON.parse(cat.logo_web) : {},
                logo_mobile: cat.logo_mobile ? JSON.parse(cat.logo_mobile) : {},
            })).sort((c1, c2) => c1.sequence - c2.sequence));
        }).finally(() => {
            setLoading(false);
        })

        ApiService.get('/categories/check_sequence').then(response => {
            if(response.data.initialized_sequence == false) {
                const ret = window.confirm("The sequence of epos_categories table has not yet been initialize.\nDo you want to initialize now?");
                if(ret == true) {
                    ApiService.get('/categories/initialize_sequence').then(() => {
                        toast.success("Initialize Success");
                    })
                }
            }
        })
    }, []);

    const onCategorySelected = (category) => {
        setSelectedCategory(category);
    }

    const onCategoryUpdated = (category) => {
        setCategories(categories.map(cat => {
            if (cat.category_id == category.category_id) {
                return {
                    ...category,
                    active: true,
                };
            } else {
                return cat;
            }
        }))
        toast.success("Category updated successfully.");
    }

    return (
        <>
            <div className="category-list d-flex">
                <CategoryTree categories={categories} setCategories={setCategories} onCategorySelected={onCategorySelected} />
                <CategoryEdit className="ms-4 flex-fluid" category={selectedCategory} onCategoryUpdated={onCategoryUpdated} />
            </div>

            { loading && <LoadingIndicator show={loading} fullScreen={true} /> }
            { initializingSequence && <LoadingIndicator show={initializingSequence} fullScreen={true} message="Initializing sequence in epos_categories table" /> }
        </>
    )
}

export default CategoryList;